import About from "../pages/About";
import Projects from "../pages/Projects";
import Contact from "../pages/Contact";
import {Blog} from "../pages/Blog";
import {BlogDetail} from "../pages/BlogDetail";

export const routes = [
    {
        label: "About",
        element: <About/>,
        path: "/",
        displayNav: true,
    },
    {
        label: "Projects",
        element: <Projects/>,
        path: "/projects",
        displayNav: true,
    },
    {
        label: "Blog",
        element: <Blog/>,
        path: "/blog",
        displayNav: true,
    },
    {
        label: "Blog Detail",
        element: <BlogDetail/>,
        path: "/blog/:id",
        displayNav: false,
    },
    {
        label: "Contact",
        element: <Contact/>,
        path: "/contact",
        displayNav: true,
    },
];
